/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import Layout from "../components/Layout";
import PrintSettings from "../components/PrintSetting";
import {
  fetchReceives,
  getPrintSettings,
  savePrintSettings,
} from "../services/api";
import { toast } from "react-toastify";
import TableReceive from "../components/TableReceive";
import PrintReceive from "../components/PrintReceive";
import { ReceiveTypes } from "../types/receive";
import { PrintSettingsStateTypes } from "../types/print_settings";

const initialPrintSettings: PrintSettingsStateTypes = {
  showName: true,
  showPrice: true,
  showCode: true,
  showBarcode: true,
  showDate: true,
  showDisplay: false,
  showPriceDisplay: true,
  showCodeDisplay: true,
  showNameDisplay: true,
  showDateDisplay: true,
  barcodeWidth: 2,
  barcodeHeight: 60,
  pageWidth: 15,
  pageHeight: 5,
  fontSize: 16,
  fontPrice: 16,
  marginTop: 3,
  marginBottom: 0,
  marginLeft: 10,
  marginRight: 10,
  barcodeType: "CODE128",
  printPerLine: 2,
  displayQuantity: 1,
  printQuantity: 1,
  printLine: "2",
  printGrouping: "item",
};

const buildReceiveKey = (item: ReceiveTypes) =>
  `${item.transNumber}::${item.itemNumber}`;

const Receive: React.FC = () => {
  const [query, setQuery] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [printSettings, setPrintSettings] =
    useState<PrintSettingsStateTypes>(initialPrintSettings);
  const [receives, setReceives] = useState<ReceiveTypes[]>([]);

  const fetchPrintSettings = useCallback(async () => {
    try {
      const data = await getPrintSettings();
      if (data?.data && data?.data?.printSettings) {
        const printSettings = JSON.parse(data?.data?.printSettings);
        setPrintSettings(printSettings?.payloadPrintSetting);
      }
    } catch (err: any) {}
  }, []);
  useEffect(() => {
    fetchPrintSettings();
  }, []);

  const handleChange = async (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, type, value } = e.target;
    const newSettings = {
      ...printSettings,
      [name]: type === "checkbox" ? e?.target?.checked : value,
    };
    await savePrintSettings(newSettings);

    setPrintSettings(newSettings);
  };

  const handleSearch = async () => {
    if (!query.trim()) return;
    setIsLoading(true);
    try {
      const response = await fetchReceives(query);
      if (response?.data) {
        const nextReceives = response.data.map((item: ReceiveTypes) => ({
          ...item,
          printQty: item.itemQty,
        }));

        setReceives((prevReceives) => {
          const existingKeys = new Set(prevReceives.map(buildReceiveKey));
          const appendedReceives = nextReceives.filter(
            (item) => !existingKeys.has(buildReceiveKey(item)),
          );

          return [...prevReceives, ...appendedReceives];
        });
      } else {
        toast.error("Data not found", { position: "top-right" });
      }
    } catch (error) {
      toast.error(error instanceof Error ? error.message : "Data not found", {
        position: "top-right",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout breadcrumbTitle="Receive">
      <div className="w-full bg-white p-6 rounded-lg shadow-md">
        <div className="p-8">
          <h1 className="text-2xl font-bold mb-4">Search Receive</h1>
          <div className="flex gap-2 mb-4">
            <input
              type="text"
              className="border border-gray-300 p-2 rounded w-full"
              placeholder="Enter Transaction Number"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            />
            <button
              onClick={handleSearch}
              disabled={isLoading || !query}
              className={`px-4 py-2 rounded ${
                isLoading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600 text-white"
              }`}
            >
              {isLoading ? "Loading..." : "Search"}
            </button>
          </div>
          {receives.length > 0 && (
            <div className="border p-4 rounded shadow-md">
              <TableReceive datas={receives} setDatas={setReceives} />
              <PrintSettings
                printSettings={printSettings}
                fetchPrintSettings={fetchPrintSettings}
              />
              <PrintReceive
                settings={printSettings}
                handleChange={handleChange}
                data={receives}
              />
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Receive;
